import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ef-send-journal-entry-presenter',
    templateUrl: './send-journal-entry-presenter.component.html',
    styleUrls: ['./send-journal-entry-presenter.component.scss'],
    standalone: false
})
export class SendJournalEntryPresenterComponent implements OnInit {
    @Input() Filter: {
        PayPeriodEndDate: Date;
        LaborAccrualDate: Date;
        LeaveAccrualDate: Date;
    };
    @Input() externalIntegration: boolean;
    @Output() SendPayPeriodLabor = new EventEmitter();
    @Output() SendAccruals = new EventEmitter();
    @Output() SendLeaveAccruals = new EventEmitter();
    @Output() SendGovConPayPayroll = new EventEmitter();
    constructor() {
        //todo: do stuff
    }

    ngOnInit(): void {
        //todo: do stuff
    }
}
